import AToast from './Toast';
// 创建子类方法
import createApp from '@/utils/createApp';
import Vue from 'vue';

let vm;
/**
 * Alert
 * @param {Object}} 内容 
 * @param {Object} 其他参数 
 */
const Toast = (content, {
    type = '',
    position = 'center',
    time = 2000,
    closeable = true
} = {}) => {
    vm = createApp(Vue, AToast);
    vm.type = type;
    vm.position = position;
    vm.closeable = closeable;
    vm.content = content;
    vm.time = time;
    // 防止2次isShow的改变被合并成一次, 防止watch会失效
    vm.$nextTick(() => {
        vm.isShow = true;
    });
    // 监听
    vm.$on('update:isShow', isShow => {
        vm.isShow = isShow;
    });

    // 关闭
    vm.close = () => {
        vm.isShow = false;
    };
    return vm;
};

Toast.close = () => {
    Vue.nextTick(() => {
        vm.isShow = false;
        // vm.$destroy();
    });
};

// 组件内调用: this.$toast | this.$toast.close()
Vue.prototype.$toast = Toast;

Vue.prototype.$loading = (text)=>{
    Toast(text, {time:0, type:'loading'});
};

Vue.prototype.$loading.close = Toast.close;
export default Toast;


// WEBPACK FOOTER //
// ./src/packages/Toast/index.js